import { render } from "./LogComponent.vue?vue&type=template&id=21f2861b&scoped=true"
import script from "./LogComponent.vue?vue&type=script&lang=js"
export * from "./LogComponent.vue?vue&type=script&lang=js"

import "./LogComponent.vue?vue&type=style&index=0&id=21f2861b&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f2861b"]])

export default __exports__